import { render, staticRenderFns } from "./Fight.vue?vue&type=template&id=0b38fb57&scoped=true&"
import script from "./Fight.vue?vue&type=script&lang=js&"
export * from "./Fight.vue?vue&type=script&lang=js&"
import style0 from "./Fight.vue?vue&type=style&index=0&id=0b38fb57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38fb57",
  null
  
)

export default component.exports